// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.first-badge {
  background-color: #0a4fae1c !important;
  color: #0a56ae;
  border: none;
  /* Optional */
  padding: 4px 8px;
}

.second-badge {
  background-color: #ae4c0a1c !important;
  color: #913e07;
  border: none;
  /* Optional */
  padding: 4px 8px;
}

.custom-badge {
  display: flex;
  /* Ensures it wraps content properly */
  align-items: center;
  justify-content: center;
  background-color: #3e9abe !important;
  color: white !important;
  padding: 2px 5px;
  font-size: 12px;
  /*border-radius: 0 0 0 0;*/
  width: 52px;
  height: 19px;
  gap: 6px;
  /* This only works if it has flex properties */
}

.header-card {
  background-color: #f9fcff;
  border: 1px solid #7ac7ff;
  border-radius: 16px;
  padding: 16px;
  gap: 8px;
}

.candidate-card {
  background-color: #f9fcff;
  border: 1px solid #7ac7ff;
  border-radius: 8px;
  padding: 6px 16px;
  margin-bottom: 16px;
}

.date-info {
  padding-left: 24px;
  padding-right: 24px;
  gap: 8px;
}

.info-card {
  background-color: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 3px;
  padding: 6px 8px;
  margin-bottom: 0;
}

.icon-button {
  background-color: #3f88e4;
  color: #ffffff;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.chevron-icon {
  align-items: center;
  display: flex;
  font-size: 24px;
}`, "",{"version":3,"sources":["webpack://./../assessment/src/pages/ResultsDashboard/ResultsDashboard.scss"],"names":[],"mappings":"AAAA;EACE,sCAAA;EACA,cAAA;EACA,YAAA;EAAc,aAAA;EACd,gBAAA;AAEF;;AACA;EACE,sCAAA;EAEA,cAAA;EACA,YAAA;EAAc,aAAA;EACd,gBAAA;AAEF;;AACA;EACE,aAAA;EAAe,sCAAA;EACf,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EAAU,8CAAA;AAIZ;;AADA;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;AAIF;;AADA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAIF;;AADA;EACE,kBAAA;EACA,mBAAA;EACA,QAAA;AAIF;;AADA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAIF;;AADA;EACE,yBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAIF;;AADA;EACE,mBAAA;EACA,aAAA;EACA,eAAA;AAIF","sourcesContent":[".first-badge {\n  background-color: #0a4fae1c !important;\n  color: #0a56ae;\n  border: none; /* Optional */\n  padding: 4px 8px;\n}\n\n.second-badge {\n  background-color: #ae4c0a1c !important;\n\n  color: #913e07;\n  border: none; /* Optional */\n  padding: 4px 8px;\n}\n\n.custom-badge {\n  display: flex; /* Ensures it wraps content properly */\n  align-items: center;\n  justify-content: center;\n  background-color: #3e9abe !important;\n  color: white !important;\n  padding: 2px 5px;\n  font-size: 12px;\n  /*border-radius: 0 0 0 0;*/\n  width: 52px;\n  height: 19px;\n  gap: 6px; /* This only works if it has flex properties */\n}\n\n.header-card {\n  background-color: #f9fcff;\n  border: 1px solid #7ac7ff;\n  border-radius: 16px;\n  padding: 16px;\n  gap: 8px;\n}\n\n.candidate-card {\n  background-color: #f9fcff;\n  border: 1px solid #7ac7ff;\n  border-radius: 8px;\n  padding: 6px 16px;\n  margin-bottom: 16px;\n}\n\n.date-info {\n  padding-left: 24px;\n  padding-right: 24px;\n  gap: 8px;\n}\n\n.info-card {\n  background-color: #ffffff;\n  border: 1px solid #eaecf0;\n  border-radius: 3px;\n  padding: 6px 8px;\n  margin-bottom: 0;\n}\n\n.icon-button {\n  background-color: #3f88e4;\n  color: #ffffff;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n}\n\n.chevron-icon {\n  align-items: center;\n  display: flex;\n  font-size: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
